import { z } from 'zod';

/**
 * E.164: `+`, then a leading 1–9 and up to 14 more digits. The one copy of the
 * rule for every schema that carries a dialable number (ADR-318); restated
 * copies drifted before.
 */
export const E164_PATTERN = /^\+[1-9]\d{1,14}$/;

/** A dialable number in E.164 form. */
export const e164Schema = z.string().regex(E164_PATTERN, 'E.164 format required');
